import React from 'react'
import PropTypes from 'prop-types'
import HashAnchor from '../HashAnchor/HashAnchor'

const PrivacyPolicyDE = ({ mobile = true }) => {
  return (
    <>
      <h2>Lifesum/Movesum Datenschutzerklärung</h2>
      <h3>Verantwortlicher für personenbezogene Daten</h3>
      <p>
        Verantwortlich für die Verarbeitung Ihrer personenbezogenen Daten ist:
      </p>
      <dl>
        <dt>NAME DES UNTERNEHMENS</dt>
        <dd>Lifesum AB</dd>

        <dt>UNTERNEHMENSIDENTIFIKATIONSNUMMER</dt>
        <dd>556729-2841</dd>

        <dt>ANSCHRIFT</dt>
        <dd>
          Repslagargatan 17B, <br />
          118 46 Stockholm, Schweden
        </dd>

        <dt>E-mail</dt>
        <dd>
          {mobile && 'contact@lifesum.com'}
          {!mobile && (
            <a href="mailto:contact@lifesum.com">contact@lifesum.com</a>
          )}
        </dd>
      </dl>
      <h3>Information zu den von uns erhobenen personenbezogenen Daten</h3>
      <p>
        Wenn du dich für die Nutzung der Services von Lifesum registrierst,
        erheben wir von dir unter anderem folgende personenbezogene Daten:
      </p>
      <p>
        Wenn du die Services von Lifesum weiter nutzt, lädst du regelmäßig
        personenbezogene Daten auf dein Konto hoch. Je nachdem, wie du die
        Services nutzt, gehören dazu: dein Kalorienverbrauch, dein Ziel für die
        Gewichtsabnahme/Gewichtszunahme, Routinen Aktivitäten/Ernährung, deine
        Körpermaße und dein BMI.
      </p>
      <p>
        Wenn du die Services von Lifesum nutzt, erheben wir auch Daten von
        deinem Gerät, unter anderem die Gerätekennung und Merkmale, die
        App-Version, die OS-Version sowie ungenaue Daten über deinen Standort.
      </p>
      <p>
        Du kannst Lifesum auch optional mit Gesundheits-Apps und Schrittzählern
        von Drittanbietern verbinden und uns erlauben, Daten zu Kalorienzufuhr,
        Trainingseinheiten, Schritten und zur Flüssigkeitsaufnahme zu erheben
        und mit diesen Anbietern zu teilen.
      </p>
      <h3>So verwenden wir deine personenbezogenen Daten</h3>
      <p>
        Deine Privatsphäre ist uns wichtig und wir verarbeiten deine
        personenbezogenen Daten nur in Übereinstimmung mit dieser
        Datenschutzerklärung und den einschlägigen Vorschriften zum Schutz
        personenbezogener Daten.
      </p>
      <h3>So verwenden wir deine personenbezogenen Daten</h3>
      <p>
        Um dir unsere Services zur Verfügung stellen zu können, verarbeiten wir
        die personenbezogenen Daten, die du bei der Registrierung an uns
        übermittelst. Dazu gehören unter anderem:
      </p>
      <ul>
        <li>Vor- und Nachname</li>
        <li>E-Mail-Adresse</li>
        <li>Geburtsdatum</li>
        <li>Wohnsitzland</li>
        <li>Gewicht</li>
        <li>Größe</li>
        <li>
          Gerätekennung, d. h. Informationen darüber, welches Gerät, welche
          IP-Adresse usw. du nutzt, um dich für die Services zu registrieren und
          dich einzuloggen Mit der weiteren Nutzung der Services wirst du
          Lifesum regelmäßig weitere personenbezogene Daten zur Verfügung
          stellen. Aus der Art der Services folgt, dass wir die Daten, die du
          für die Services hochlädst, verarbeiten müssen, um diese für dich
          bereitzustellen. So verarbeiten wir zum Beispiel deine Angaben zu
          Gewicht und Kalorienaufnahme, um deine persönlichen Ziele zu tracken
          und darzustellen (ob Gewichtsabnahme oder Gewichtszunahme). Die
          Verarbeitung dieser Daten ist erforderlich, damit wir unseren Vertrag
          mit dir erfüllen können und kann darüber hinaus aus dem berechtigten
          Interesse erfolgen, unser Produkt zu verbessern.
        </li>
      </ul>
      <p>
        Wenn du dich über eine Drittanbieter-Anwendung wie Facebook Login oder
        Google Auth zur Authentifizierung mit den Services verbindest, erhebt
        Lifesum deine personenbezogenen Daten von diesen
        Drittanbieter-Anwendungen, um diese anschließend zu verarbeiten. Hierzu
        gehören unter anderem Benutzername, Name, Profilbild, Land, Wohnort,
        E-Mail-Adresse, Geburtsdatum und Geschlecht. Auch, wenn du dein Lifesum
        Konto mit einer Drittanbieter-Anwendung wie Apple HealthKit, Google
        Health Connect, Fitbit, Withings, Oura, Runkeeper oder Garmin
        verbindest, um Informationen zu Nahrungsaufnahme, Training,
        Flüssigkeitsaufnahme, Schlaf oder Schritten zu tracken, kann Lifesum
        diese Daten mit der Drittanbieter-Anwendung teilen und sie verarbeiten,
        um die gewünschte Integration zu ermöglichen. Weitere Informationen
        darüber, wie diese Dritten deine Daten verarbeiten, findest du in den
        jeweiligen Datenschutzerklärungen.
      </p>
      <ul>
        <li>
          Wenn du uns die Erlaubnis erteilst, deine Trainings-, Ernährungs-,
          Kalorien- oder Schrittdaten aus einer Drittanbieter-Anwendung zu
          lesen, können wir diese verwenden, um deine Tagebuchansicht
          automatisch auszufüllen, deine Kalorienziele zu berechnen und dir
          wöchentlich Life Score-Empfehlungen zur Verfügung zu stellen.
        </li>
        <li>
          Wenn du uns die Erlaubnis erteilst, deine Schlafdaten aus einer
          Drittanbieter-Anwendung zu lesen, können wir diese nutzen, um zu
          visualisieren, wie die Qualität deines Schlafs mit deiner Ernährung
          und deinem Training zusammenhängt.
        </li>
        <li>
          Wenn du uns die Erlaubnis erteilst, Daten zu Ernährung und
          Flüssigkeitsaufnahme aus einer Drittanbieter-Anwendung zu lesen,
          kannst du die Benutzeroberfläche und die Lebensmitteldatenbank von
          Lifesum nutzen, um deine Ernährungs- und Trinkgewohnheiten über
          mehrere Systeme gleichzeitig zu tracken.
        </li>
      </ul>
      <p>
        Einige der oben genannten Daten, die von dir erhoben und von Lifesum für
        bestimmte Funktionen der Services verarbeitet werden, können wir auf
        deine Anfrage hin löschen und zukünftig nicht weiter verarbeiten, ohne
        dass du die Nutzung der gesamten Services einstellen musst, d. h. nicht
        alle Daten (die du uns im Laufe der Zeit entweder direkt oder über
        Dienste Dritter übermittelt hast) sind erforderlich, damit du die
        Services weiterhin nutzen kannst. Wenn du möchtest, dass bestimmte Daten
        aus dieser Kategorie nicht mehr von uns verarbeitet werden, informieren
        wir dich darüber, welche Folgen sich daraus ergeben, d. h. wie sich dies
        auf deine Nutzung der Funktionen der Services auswirkt.
      </p>
      <h3>Rechtliche Grundlage für die Verarbeitung deiner Daten</h3>
      <p>
        Um dir die Apps und Services von Lifesum zur Verfügung zu stellen, ist
        die Verarbeitung deiner personenbezogenen Daten erforderlich, um den mit
        dir geschlossenen Vertrag zu erfüllen.
      </p>
      <p>
        Darüber hinaus verarbeiten wir deine personenbezogenen Daten aus dem
        berechtigten Interesse, unsere Services und Kommunikation mit dir zu
        verbessern.
      </p>
      <p>
        Mit deiner Einwilligung können Daten auch zur Personalisierung von
        Werbung verwendet werden.
      </p>
      <p>
        Darüber hinaus werden einige Daten verarbeitet, um gesetzlichen
        Verpflichtungen nachzukommen.
      </p>
      <h3>Profiling</h3>
      <p>
        Die Services von Lifesum basieren auf fundierten Kenntnissen zu Best
        Practices im Bereich Gesundheit. Lifesum arbeitet mit
        Ernährungsspezialisten, Verhaltenspsychologen, Personal Trainern und
        Stressexperten zusammen, um stets auf dem neuesten Stand von Forschung
        und Wissenschaft zu sein. Außerdem analysiert Lifesum die Nutzung der
        Services, um dir als Benutzer die relevantesten Funktionen der Services
        zur Erreichung deiner persönlichen Ziele anzubieten. Bei der Analyse der
        Nutzung der Services verarbeitet Lifesum bestimmte Daten für das
        sogenannte Profiling. Profiling bezeichnet die Verarbeitung deiner Daten
        und der personenbezogenen Daten anderer Benutzer, um Informationen dazu,
        wie du die Services nutzt sowie zu deinem Verhalten und zu deinem
        Standort bei der Erreichung deines Gesundheitsziels zu analysieren oder
        vorherzusagen. Wir verarbeiten die Daten, um mehr über
        Nutzergewohnheiten zu erfahren und tracken in diesem Zusammenhang
        verschiedene Aktivitäten, die du über die Services ausführst, z. B. wenn
        du zwischen Bildschirmen wechselst, Schaltflächen anklickst und sonstige
        Aktivitäten durchführst. Profiling hat zum Ziel, das Engagement der
        Benutzer im Hinblick auf die verschiedenen Funktionen unseres Services
        zu beobachten, neue Lösungen zu finden, um unseren Service effektiver zu
        gestalten (passend zum Zweck) und die Funktionen und Inhalte noch besser
        an dein individuelles Nutzungsverhalten und deine Präferenzen
        anzupassen.
      </p>
      <p>
        Das Profiling deiner Daten kann auch als Grundlage für
        Marketingmaßnahmen gegenüber neuen potenziellen Kunden auf anderen
        Plattformen als den LIFESUM Services, wie z. B. anderen
        Social-Media-Plattformen, verwendet werden. Bitte beachte, dass dieser
        sogenannte Lookalike-Ansatz zur Neukundengewinnung nicht bedeutet, dass
        Marketing an dich gerichtet wird. Ebenso wenig bedeutet dies, dass
        Drittparteien für andere Zwecke als die Ansprache neuer Kunden durch
        LIFESUM Zugriff auf deine Daten erhalten, d. h. Drittanbieter (zum
        Beispiel soziale Medien) werden deine Daten nur als Auftragsverarbeiter
        verarbeiten; weitere Details findest du im unten stehenden Abschnitt zur
        Datenübermittlung.
      </p>
      <h3>Direktmarketing</h3>
      <p>
        Lifesum kann deine personenbezogenen Daten für Profiling- und
        Direktmarketingzwecke über E-Mails, Benachrichtigungen oder andere
        Nachrichten von Lifesum oder ausgewählten Geschäftspartnern von Lifesum
        verwenden. Profiling wird zu Marketingzwecken verwendet, um dir auf
        Grundlage deiner Präferenzen personalisierte und relevante Angebote
        zukommen zu lassen. Weitere Details findest du im oben stehenden
        Abschnitt Profiling.
      </p>
      <p>
        Die Verwendung personenbezogener Daten für Direktmarketingzwecke
        betrifft nur Angebote, die in engem Zusammenhang mit deiner Nutzung des
        Services stehen, und du erhältst diese Angebote von Lifesum. Diese
        Verarbeitung basiert auf einem berechtigten Interesse auf unserer Seite
        daran, dir den bestmöglichen Service zu bieten, auf deiner Seite daran,
        Angebote für Produkte und Dienstleistungen zu erhalten, die relevant für
        deine Nutzung des Services sind, und für Drittparteien daran, dich über
        solche Angeboten erreichen zu können.
      </p>
      <h3>Abmeldung vom Direktmarketing</h3>
      <p>
        Falls du nicht möchtest, dass Lifesum deine personenbezogenen Daten für
        Direktmarketingzwecke nutzt, kannst du dich jederzeit von weiteren
        Nachrichten abmelden, indem du auf den Link "Abmelden", der am Ende
        einer solchen Nachricht aufgeführt wird, klickst oder die Opt-out-Option
        in den App-Einstellungen des Services wählst.
      </p>
      <h3>In-App-Werbung</h3>
      <p>
        Lifesum kann dir in der kostenlosen Version der App Werbung anzeigen.
        Mit deiner Zustimmung können die Daten verwendet werden, um ein Profil
        deiner Interessen zu erstellen und diese Profilinformationen zu
        verwenden, um relevantere Anzeigen für dich zu schalten. Benutzern, die
        der Personalisierung von Anzeigen nicht zustimmen, können wir auf der
        Grundlage berechtigter Interessen jedoch auch weiterhin nicht
        personalisierte Anzeigen präsentieren.
      </p>
      <HashAnchor use="h3" id="cookies">
        <h3>Cookies</h3>
      </HashAnchor>
      <p>
        Lifesum verwendet Cookies, um das ordnungsgemäße Funktionieren seiner
        Services zu ermöglichen. Wir verwenden sowohl Sitzungs-Cookies (die beim
        Schließen des Browsers gelöscht werden) als auch dauerhafte Cookies (die
        für eine bestimmte Zeit auf deinem Gerät verbleiben bzw. so lange, bis
        du sie löschst).
      </p>
      <p>
        Ein Cookie ist eine kleine Textdatei, die von den Websites erstellt
        wird, die du besucht hast und Informationen über dich als Besucher
        enthalten kann. Diese Textdateien werden auf deinem Gerät gespeichert
        und sorgen beispielsweise dafür, dass du dir dein Passwort nicht selbst
        merken musst. Informationen aus Cookies können verwendet werden, um die
        Benutzererfahrung und/oder die Services zu verbessern und
        Marketingkampagnen und Angebote auf unsere Kunden auszurichten.
      </p>
      <p>
        Wenn du Cookies ablehnst, werden diese nicht auf deinem Gerät
        gespeichert. Dies kannst du über das Cookie-Banner tun, das dir auf der
        Webseite angezeigt wird. Du kannst deine Cookie-Präferenzen jederzeit
        ändern. Gehe hierzu in den Hilfebereich deines Internetbrowsers. Wenn du
        Cookies ablehnst, kannst du unsere Services weiterhin nutzen, jedoch
        eventuell mit eingeschränkter Funktionalität.
      </p>
      <h3>Zugang, Berichtigung und Löschung personenbezogener Daten</h3>
      <p>
        Du hast das Recht, Zugang zu deinen von Lifesum verarbeiteten
        personenbezogenen Daten zu erhalten sowie deren Berichtigung oder
        Löschung zu verlangen. Wenn du diese Rechte ausüben möchtest,
        kontaktiere uns bitte unter https://lifesum.com/contact. Alternativ
        kannst du deine personenbezogenen Daten auch löschen, indem du dein
        Konto über die Services löschst.
      </p>
      <p>
        Wenn sich dein Antrag auf Löschung auf Daten bezieht, die Lifesum
        benötigt, um die Services bereitzustellen, hat dieser zur Folge, dass
        auch dein Konto bei Lifesum beendet wird. In einigen Fällen kann Lifesum
        jedoch das Verarbeiten einiger personenbezogener Daten für bestimmte
        Teile der Lifesum Services einstellen, ohne dass du die Nutzung aller
        Lifesum Services beenden musst. Weitere Informationen hierzu findest du
        in den oben stehenden Abschnitten 'Erforderliche Datenverarbeitung für
        die Bereitstellung der Services' und 'Abmelden vom Direktmarketing'.
      </p>
      <h3>Aufbewahrung und Speicherung deiner personenbezogenen Daten</h3>
      <p>
        Außer wenn du dein Konto löschst, die Berichtigung oder Löschung der
        entsprechenden personenbezogenen Daten verlangst oder dich von der
        Verarbeitung der Daten im Zusammenhang mit Marketing abmeldest,
        speichern und verarbeiten wir deine personenbezogenen Daten, solange du
        ein registrierter Benutzer unserer Services bist und ein Benutzerkonto
        hast. Wir werden deine personenbezogenen Daten anonymisieren oder die
        Speicherung und Verarbeitung einstellen, wenn dein Benutzerkonto/deine
        Registrierung beendet wird oder wenn du einen Antrag auf Löschung deiner
        Daten stellst, es sei denn, es ist aus zutreffenden Zwecken für uns
        erforderlich, die entsprechenden personenbezogenen Daten für längere
        Zeit zu speichern oder zu verarbeiten (z. B. für buchhalterische
        Zwecke).
      </p>
      <p>
        Darüber hinaus überprüfen wir regelmäßig die Notwendigkeit, deine
        personenbezogenen Daten zu speichern oder zu löschen, wenn dein Konto
        inaktiv war, was in der Regel zutrifft, wenn du die Services von Lifesum
        für einen Zeitraum von fünf (5) Jahren dauerhaft nicht genutzt hast.
        Diese regelmäßigen Überprüfungen führen wir durch, um sicherzustellen,
        dass wir deine personenbezogenen Daten nicht länger als nötig speichern
        und dir gleichzeitig zu ermöglichen, dein Konto nach einer gewissen Zeit
        der Inaktivität (was unserer Erfahrung nach häufiger vorkommt) wieder zu
        nutzen.
      </p>
      <h3>Datenübermittlung</h3>
      <p>
        Lifesum kann von dir erhobene personenbezogene Daten mit Drittanbietern
        teilen, die personenbezogene Daten im Auftrag von Lifesum verarbeiten;
        hierzu gehören unter anderem Hosting-Anbieter, Datenspeicheranbieter,
        Unternehmen, die das Performance-Monitoring für unsere Systeme und
        unseren Vertrieb durchführen, Anbieter von Kundensupport-Systemen sowie
        Zahlungsdienstleister.
      </p>
      <p>
        Gelegentlich kann es vorkommen, dass ein Teil deiner personenbezogenen
        Daten wie oben beschrieben an Dritte übermittelt und von diesen
        verarbeitet wird, die in den Vereinigten Staaten oder anderen Ländern
        ansässig sind (in einigen Fällen auch außerhalb des EWR). Wenn unser
        Unternehmen (oder ein Teil davon) veräußert wird, zum Beispiel im Rahmen
        einer Fusion oder Übernahme, können wir deine personenbezogenen Daten
        auch übermitteln. Lifesum wird stets Sicherheitsvorkehrungen treffen, um
        deine personenbezogenen Daten vor unbefugter Veröffentlichung zu
        schützen. Im Falle der Übermittlung von Daten an Dritte, die sich
        außerhalb der EU oder des EWR befinden und kein angemessenes
        Datenschutzniveau bieten, wendet Lifesum die EU-Modellklauseln und/oder
        andere verbindliche interne Unternehmensrichtlinien oder ähnliche
        Instrumente/Mechanismen an, um die Integrität und Sicherheit der Daten
        zu gewährleisten.
      </p>
      <p>
        Darüber hinaus kann Lifesum deine personenbezogenen Daten
        veröffentlichen, um einer gesetzlichen oder behördlichen Verpflichtung
        nachzukommen, wenn für uns ein hinreichender Grund zur Annahme besteht,
        dass dies durch Gesetze, Verordnungen oder andere Rechtsvorschriften
        oder dafür erforderlich ist, Lifesum, unsere Geschäftspartner oder die
        Rechte und Interessen von Benutzern zu schützen und zu verteidigen,
        vorbehaltlich der jeweils geltenden Bestimmungen zum Schutz
        personenbezogener Daten.
      </p>
      <h3>Datenübertragbarkeit</h3>
      <p>
        In Übereinstimmungen mit den einschlägigen Vorschriften zum Schutz
        personenbezogener Daten hast du das Recht, die personenbezogenen Daten,
        die du Lifesum zur Verfügung gestellt hast, zu erhalten, sofern dies
        nicht die Grundrechte und Grundfreiheiten anderer einschränkt.
      </p>
      <h3>Beschwerden</h3>
      <p></p>
      <h3>Zugriff, Berichtigung und Löschung personenbezogener Daten</h3>
      <p>
        Sie haben das Recht, den Zugriff auf Ihre von Lifesum verarbeiteten
        personenbezogenen Daten sowie deren Berichtigung oder Löschung zu
        verlangen. Sollten Sie dieses Recht ausüben wollen, kontaktieren Sie uns
        bitte unter https://lifesum.com/contact. Es muss ein schriftlicher
        Antrag erfolgen, der von Ihnen zu unterschreiben ist. Sie können Ihre
        personenbezogenen Daten aber auch löschen, indem Sie Ihr Konto über die
        Dienste löschen.
      </p>
      <p>
        Wenn sich ein Antrag auf Löschung auf Daten bezieht die für die von
        Lifesum angebotenen Dienste erforderlich sind, werden solche Anträge
        dazu führen, dass Ihr Konto bei Lifesum beendet wird. In einigen Fällen
        kann Lifesum jedoch die Verarbeitung einiger personenbezogener Daten für
        bestimmte Teile der Lifesum-Dienste einstellen, ohne dass Sie die
        Nutzung der gesamten Lifesum-Dienste beenden müssen. Bitte beachten Sie
        hierzu die Abschnitte „Datenverarbeitung ist erforderlich, um Dienste
        anzubieten“ und „Opt-out im Bezug auf Werbung“ weiter oben.
      </p>
      <h3>Erhaltung und Speicherung Ihrer personenbezogenen Daten</h3>
      <p>
        Sofern Sie Ihr Konto nicht löschen, keine Berichtigung oder Löschung der
        relevanten personenbezogenen Daten beantragen oder die Verarbeitung im
        Zusammenhang mit Marketing ablehnen, speichern und verarbeiten wir Ihre
        personenbezogenen Daten im Allgemeinen, solange Sie ein registrierter
        Benutzer unserer Dienste sind und ein Benutzerkonto haben. Wir werden
        die Speicherung und Verarbeitung Ihrer personenbezogenen Daten
        einstellen, sobald Ihr Benutzerkonto / Ihre Registrierung beendet wird,
        Sie eine Berichtigung oder Löschung beantragen oder die Teilnahme an
        Marketing deaktivieren - es sei denn, wir müssen die entsprechenden
        personenbezogenen Daten für die entsprechenden Zwecke für einen längeren
        Zeitraum speichern oder verarbeiten (z.B. für Buchhaltungszwecke).
      </p>
      <p>
        Darüber hinaus überprüfen wir regelmäßig die Notwendigkeit, Ihre
        persönlichen Daten zu speichern oder zu löschen, falls Ihr Konto über
        einen längeren Zeitraum inaktiv war. Dies geschieht normalerweise nach
        einem Zeitraum von fünf (5) Jahren, wenn Sie die Lifesum Dienste
        dauerhaft nicht aktiv genutzt haben. Diese regelmäßigen Überprüfungen
        werden durchgeführt, um sicherzustellen, dass wir Ihre persönlichen
        Daten nicht länger als nötig speichern. Eine Nutzung des Kontos nach
        Inaktivitätsphasen (die gemäß unserer Erfahrung bei einigen Benutzern
        häufig vorkommen) können Sie Ihr Konto jedoch wieder verwenden.
      </p>
      <h3>Datenübermittlung</h3>
      <p>
        Von Ihnen erhobene personenbezogene Daten werden an Dienstleister, die
        im Auftrag von Lifesum personenbezogene Daten verarbeiten, z.B.
        Server-Hosting-Anbieter, Speicherplatzanbieter, Unternehmen zur
        Kontrolle von Systemleistung und Umsatzentwicklung,
        Kundenbetreuungssysteme und Zahlungsdienstleister, weitergegeben. Diese
        Dienstleister werden als Auftragsverarbeiter Ihrer personenbezogenen
        Daten betrachtet.
      </p>
      <p>
        Gelegentlich werden Teile Ihrer personenbezogenen Daten an
        Auftragsverarbeiter (s.o.) übermittelt, die Ihren Sitz in den USA oder
        anderen Staaten (einige außerhalb der EWR) haben und von solchen
        verarbeitet. Lifesum wird immer Vorsichtsmaßnahmen ergreifen, um Ihre
        Daten vor unbefugter Offenlegung zu schützen. Wir werden Ihre
        personenbezogenen Daten ggf. auch übermitteln, falls unser Geschäft
        (oder einen Teil davon) verkauft wird, z.B. als Teil einer Verschmelzung
        oder Übernahme. Für den Fall einer Übermittlung von Daten an Dritte, die
        sich außerhalb der EU oder der EWR befinden und kein ausreichendes
        Datenschutzniveau anbieten, wird Lifesum die Musterklauseln der EU
        Kommission anwenden und/oder verbindliche Unternehmensregeln oder
        ähnliche Mittel, um die Unversehrtheit und Sicherheit der Daten zu
        schützen.
      </p>
      <p>
        Keinesfalls übermittelt Lifesum personenbezogene Daten an Dritte unter
        Gewährung eines Rechts zur Nutzung dieser Daten für andere Zwecke als im
        Auftrag von Lifesum.
      </p>
      <p>
        Lifesum kann darüber hinaus Ihre personenbezogenen Daten zur Einhaltung
        von gesetzlichen oder regulatorische Pflichten offenlegen, soweit wir
        Grund zu der Annahme haben, dass dies das Gesetz, eine Verordnung oder
        andere Rechtsvorschriften verlangen, oder um Lifesum, seine
        Geschäftspartner oder die Rechte und Interessen von Nutzern zu schützen
        und zu verteidigen, wobei jedenfalls die einschlägigen
        Datenschutzvorschriften eingehalten werden.
      </p>
      <h3>Datenübertragbarkeit</h3>
      <p>
        Sie sind berechtigt die personenbezogenen Daten, die Sie Lifesum
        bereitgestellt haben, gemäß den einschlägigen Datenschutzvorschriften zu
        erhalten, soweit ein solcher Antrag nicht die Rechte und Freiheiten
        anderer beeinträchtigt.
      </p>
      <h3>Beschwerden</h3>
      <p>
        Bei Fragen oder Beschwerden im Zusammenhang mit der Verarbeitung deiner
        personenbezogenen Daten kannst du uns gerne unter
        https://lifesum.com/contact kontaktieren. Darüber hinaus hast du das
        Recht, eine Beschwerde bei der schwedischen Datenschutzbehörde (IMY)
        unter imy@imy.se einzureichen.
      </p>
      <h3>Sicherheit der von uns verarbeiteten personenbezogenen Daten</h3>
      <p>
        Die Sicherheit und Integrität deiner personenbezogenen Daten sind uns
        wichtig. Zusätzlich zur Einhaltung der anwendbaren einschlägigen
        Vorschriften zum Schutz personenbezogener Daten verwenden wir anerkannte
        Industriestandards, Technologien und Verfahren wie Firewalls,
        Sicherheitssoftware etc., um die Integrität deiner personenbezogenen
        Daten zu schützen und einen unbefugten Zugriff auf diese zu verhindern.
        Außerdem bitten wir dich, bei der Nutzung der Services von Lifesum ein
        einzigartiges und starkes Passwort für dein Benutzerkonto zu verwenden
        und es vor dem Zugriff durch unberechtigte Dritte zu schützen. Darüber
        hinaus solltest du den Zugriff auf deinen Computer und Browser weiter
        einschränken und dich nach Nutzung der Lifesum Services ausloggen.
      </p>
      <h3>Kinder</h3>
      <p>
        Wenn du unter 13 Jahre alt bist oder dein Alter unter dem in deinem Land
        gültigen Mindestalter für die Einwilligung in Dienste der
        Informationsgesellschaft liegt, je nachdem, welches Alter höher ist,
        darfst du keine personenbezogenen Daten über unsere Services zur
        Verfügung stellen. Darüber hinaus ermutigen wir Eltern und
        Erziehungsberechtigte, die Internetnutzung ihrer Kinder zu überwachen
        und uns bei der Durchsetzung unserer Datenschutzerklärung zu
        unterstützen, indem sie ihre Kinder anweisen, ohne ihre Erlaubnis keine
        personenbezogenen Daten über unseren Service bereitzustellen. Wenn du
        darüber Kenntnis erlangst, dass ein Kind, das jünger als 13 Jahre bzw.
        in einem Alter ist, das unter dem in deinem Land geltenden Mindestalter
        für die Einwilligung in Dienste der Informationsgesellschaft liegt,
        personenbezogenen Daten an uns übermittelt hat, kontaktiere uns bitte
        unter https://lifesum.com/contact.
      </p>
      <h3>Kinder</h3>
      <p>
        Sollten Sie jünger als 13 Jahre sein ist es Ihnen nicht erlaubt,
        personenbezogene Daten unter Nutzung unserer Dienste anzugeben. Überdies
        fordern wir Eltern und Erziehungsberechtigte dazu auf, die
        Internetnutzung ihrer Kinder zu überwachen und uns bei der Durchsetzung
        unserer Datenschutzerklärung zu unterstützen, indem sie ihre Kinder
        anweisen, niemals ohne ihre Erlaubnis personenbezogene Daten über
        unseren Dienst anzugeben. Wenn Sie davon erfahren, dass ein Kind unter
        13 Jahren personenbezogene Daten an uns übermittelt hat, kontaktierten
        Sie uns bitte unter https://lifesum.com/contact.
      </p>
      <h3>Änderungen an unserer Datenschutzerklärung</h3>
      <p>
        Von Zeit zu Zeit kann es notwendig werden, Änderungen an dieser
        Datenschutzerklärung vorzunehmen. Daher behalten wir uns das Recht vor,
        diese Datenschutzrichtlinie jederzeit zu aktualisieren und/oder zu
        ändern und dich entsprechend darüber zu informieren. Bitte lies dir
        diese Datenschutzerklärung regelmäßig durch, insbesondere, bevor du ein
        Konto bei uns erstellst. Das Datum der letzten Änderung ist am Ende
        dieser Datenschutzrichtlinie aufgeführt.
      </p>
      <h3>Kontakt</h3>
      <p>
        Wir werden über E-Mails und Benachrichtigungen auf deinem Mobilgerät mit
        dir kommunizieren. Wenn du keine Benachrichtigung auf deinem Mobilgerät
        erhalten möchtest, kannst du diesen Dienst jederzeit deaktivieren. Bitte
        beachte, dass du, wenn du dich von unserer Mailingliste abmeldest, keine
        Werbe-E-Mails mehr erhältst, wir jedoch auch weiterhin auf deine
        Supportanfragen antworten.
      </p>
      <p>
        Wir freuen uns über Feedback zu unseren Services. Bei Fragen oder
        Anregungen zu unserer Datenschutzerklärung kontaktiere uns bitte unter
        https://lifesum.com/contact. Unter dpo@lifesum.com kannst du dich auch
        direkt an unseren Datenschutzbeauftragten wenden.
      </p>
      <p>
        <small>Zuletzt aktualisiert: 05/24/2024</small>
      </p>
      <h2>Lifesum Allgemeine Geschäftsbedingungen</h2>
      <p>
        <small>Zuletzt aktualisiert: 06/27/2018</small>
      </p>
      <p>
        Wenn du dich als Mitglied von Lifesum registrierst oder unsere Services
        nutzt, erklärst du dich mit diesen Allgemeinen Geschäftsbedingungen //
        ('Bedingungen') einverstanden. Daher ist es wichtig, dass du dir diese
        sorgfältig durchliest. Wenn du nicht mit diesen Bedingungen
        einverstanden bist, solltest du dich nicht bei Lifesum registrieren.
      </p>
      <h3>Über Lifesum</h3>
      <p>
        Lifesum ist ein von Lifesum AB entwickelter und bereitgestellter
        Service. Er ist online unter anderem unter lifesum.com, im iPhone App //
        Store als 'Lifesum' und im Google Play Store als 'Lifesum' verfügbar.
        Der Zweck von Lifesum besteht darin, den Benutzern zu ermöglichen, ihr
        Ess- und Trinkverhalten zu dokumentieren und ihre Fortschritte in den
        Bereichen Training, Gewicht und Fitness zu tracken.
      </p>
      <h3>Nutzung unserer Services</h3>
      <p>
        Um unsere Services zu nutzen, gilt es einige einfache Regeln zu
        beachten. Die Services stehen nur für deine private Nutzung zur
        Verfügung und sind nicht für den kommerziellen Gebrauch bestimmt. Nutze
        die Services nicht auf missbräuchliche Art und Weise, um weder Lifesum
        noch andere irgendwie zu schädigen. Du darfst die Services nur im Rahmen
        des geltenden Gesetzes und gemäß diesen Bedingungen nutzen. Mit der
        Nutzung unserer Services erklärst du dich mit Folgendem einverstanden:
      </p>
      <ul>
        <li>
          Alle personenbezogenen Daten, die du zur Verfügung stellst, sind
          korrekt und aktuell.
        </li>
        <li>
          Du bist allein verantwortlich für alle Aktivitäten auf deinem Konto
          und alle Inhalte, die unter deinem Lifesum Konto hochgeladen und/oder
          erstellt werden ("Benutzermaterial").
        </li>
        <li>
          Lifesum überwacht die Inhalte des Services nicht, kann jedoch,
          jederzeit und nach eigenem Ermessen, Benutzermaterialien vom Service
          und/oder deinem Benutzerkonto entfernen und dein Konto sowie deine
          Mitgliedschaft beenden.
        </li>
        <li>
          Deine Mitgliedschaft bei Lifesum, einschließlich deiner E-Mail-Adresse
          und deines Passworts, darf nicht an andere übertragen oder von diesen
          verwendet werden. Du bist dafür verantwortlich, deine Login-Daten auf
          sichere Weise aufzubewahren. Lifesum ist in keiner Weise
          verantwortlich für jedweden Verlust oder Schaden, der durch unbefugten
          Zugriff auf dein Konto oder die Verwendung deiner Login-Daten
          verursacht wird. Wenn du Kenntnis darüber erlangst oder den Verdacht
          hast, dass dein Konto unberechtigt genutzt wird, musst du den
          Kundenservice von Lifesum unverzüglich darüber informieren. Die
          Kontaktdetails findest du am Ende dieses Dokuments.
        </li>
        <li>
          Lifesum ist nicht für die Nutzung durch Personen unter 13 Jahren
          bestimmt. Um Lifesum nutzen zu können, musst du mindestens 13 Jahre
          alt sein.
        </li>
        <li>
          Ein Verstoß gegen diese Bedingungen führt zur sofortigen Beendigung
          deines Benutzerkontos und deines Abonnements. Wenn du gegen diese
          Bedingungen verstößt, erhältst du keine Rückerstattung.
        </li>
        <li>
          Es ist dir nicht gestattet, dich an kommerziellen Aktivitäten, die wir
          im Rahmen unseres Services durchführen, zu beteiligen, zu werben
          und/oder Hinweise (wie Links) darauf zu geben.
        </li>
        <li>
          Du darfst nicht an rechtswidrigen Aktivitäten über den Service
          beteiligen und zum Beispiel (ohne darauf beschränkt zu sein) Inhalte
          zur Verfügung stellen, die in irgendeiner Weise Aufstachelung zu
          Rassenhass, Verleumdung, Belästigung, Kinderpornografie oder
          Pornografie darstellen oder beinhalten.
        </li>
        <li>
          Es ist dir nicht erlaubt, in irgendeiner Weise zur Verbreitung von
          Propaganda oder religiösen und/oder politischen Ansichten beizutragen.
        </li>
        <li>
          Bei Kritik oder Feedback zu Lifesum und unseren Services, kontaktiere
          bitte zunächst Lifesum, damit wir unsere Services verbessern können.
        </li>
        <li>
          Du darfst personenbezogene Daten anderer nicht ohne deren Zustimmung
          teilen.
        </li>
      </ul>
      <h3>Ihr Konto</h3>
      <p>
        Du kannst dein Konto jederzeit nach Belieben kündigen/beenden. Bitte
        beachte, dass dein Abonnement nicht automatisch endet, wenn du die
        mobile Anwendung deinstallierst oder dein Konto schließt – du musst das
        Abonnement aktiv kündigen. Bitte beachte, dass du dein Abonnement bei
        Lifesum, wenn du dieses über den App Store, den Google Play Store oder
        einen anderen solchen Dienstanbieter abgeschlossen hast, nur über diese
        kündigen kannst. Weitere Informationen dazu, wie du dein Abonnement
        kündigen und/oder dein Konto beenden kannst, findest du in der App oder
        auf der Website. Für Lifesum Premium gelten besondere Bedingungen.
      </p>
      <h3>Informationen zu Gesundheit und Ernährung</h3>
      <p>
        Für deine Gesundheit bist allein du verantwortlich. Lifesum ist keine
        medizinische Einrichtung und liefert dir keine medizinische Beratung
        oder Diagnosen. Der Zweck der Services besteht allein darin, unsere
        Benutzer dabei zu unterstützen, ihre Ernährungs- und
        Trainingsgewohnheiten festzuhalten und ihre Fortschritte in den
        Bereichen Ernährung, Gewicht und Fitness zu tracken. Informationen, die
        über die Services und von unseren Geschäfts- und Werbepartnern zur
        Verfügung gestellt werden, dürfen ausschließlich zum Zweck der Erholung
        und der Aufklärung verwendet werden. Du solltest immer deinen Arzt
        konsultieren, bevor du eine Diät oder ein Trainingsprogramm beginnst
        oder wenn Schmerzen oder Unwohlsein auftreten. Lifesum kann keine
        bestimmten Ergebnisse oder Verbesserungen im Hinblick auf Gesundheit,
        Gewicht und/oder Fitness garantieren. Unsere Services sind nur für
        gesunde Erwachsene bestimmt. Bitte nutze unsere Services nicht, wenn
        dein aktueller Gesundheitszustand keine Diät oder sportliche Betätigung
        erlaubt oder diesen negativ beeinträchtigen könnte. Die Nährwertangaben
        in unserer Datenbank wurden von Lifesum nicht verifiziert, untersucht
        oder überprüft. Lifesum kann nicht garantieren, dass die in unserer
        Datenbank bereitgestellten Nährwertangaben korrekt, zuverlässig oder
        vollständig sind. Lifesum haftet nicht für Personenschäden oder andere
        Schäden, die direkt oder indirekt aus der Nutzung oder dem Missbrauch
        der Services resultieren.
      </p>
      <h3>Lifesum Premium</h3>
      <p>
        Dieser Abschnitt gilt nur, wenn du ein kostenpflichtiges Abonnement von
        Lifesum Premium und/oder andere kostenpflichtige Produkte nutzt. Durch
        die Zahlung der Abonnementgebühr oder die Aktivierung eines
        Probeabonnements erhältst du für die Gültigkeitsdauer deines Abonnements
        gemäß dieser Bedingungen Zugang zu Lifesum Premium.
      </p>
      <p>Alle Abonnements für Lifesum Premium werden im Voraus bezahlt.</p>
      <p>
        Du kannst deine Mitgliedschaft jederzeit beenden. In diesem Fall ist
        deine Mitgliedschaft noch für die bezahlte Abonnementdauer gültig. Wenn
        du dein Abonnement über den App Store, den Google Play Store oder einen
        anderen solchen Dienstanbieter im Rahmen eines In-App-Kaufs erworben
        hast, kannst du es nur über diese Dienste kündigen. Die
        Abonnementgebühren findest du auf der Website von Lifesum
        (www.lifesum.com) und in der mobilen Anwendung. Lifesum akzeptiert
        verschiedene Zahlungsmethoden wie PayPal, Apple iTunes, Google Play und
        Kartenzahlung. Es können besondere Bedingungen gelten. Lifesum behält
        sich das Recht vor, die Abonnementgebühren von Zeit zu Zeit zu ändern.
      </p>
      <p>
        Du erklärst dich hiermit einverstanden, die Services von Lifesum Premium
        oder anderer bezahlter Produkte unverzüglich nach Abschluss des
        Abonnements zu nutzen. Das bedeutet, dass du ab dem Datum, an dem du die
        Bestätigung deines Abonnements per E-Mail erhalten hast, nur 14 Tage
        Zeit hast, um vom Vertrag mit Lifesum zurückzutreten, wenn du während
        dieses Zeitraums nicht mit der Nutzung der Services beginnst. Um vom
        Rücktrittsrecht Gebrauch zu machen, musst du eine E-Mail an Lifesum
        senden (die Kontaktdetails findest du am Ende dieses Dokuments). Alle im
        Voraus bezahlten Gebühren werden innerhalb von 30 Tagen zurückerstattet.
        Alle von Apple abgewickelten Zahlungen, zum Beispiel bei In-App-Käufen,
        werden nur von Apple und mit Zustimmung von Apple zurückerstattet. Wenn
        du Apple kontaktieren möchtest, klicke bitte hier. Zahlungsverzug gilt
        nicht als Beendigung eines Lifesum Premium-Abonnements.
      </p>

      <h3>Geistiges Eigentum</h3>
      <p>
        Alle Rechte an und bezüglich der Services, einschließlich aller
        eingetragenen Marken, Dienstleistungsmarken, Handelsnamen und
        urheberrechtlich geschützten Inhalte (zusammen als "geistiges Eigentum"
        bezeichnet), die im Rahmen des Services präsentiert werden, sind
        Eigentum von Lifesum und/oder Dritten. Du erklärst dich damit
        einverstanden, Geistiges Eigentum für keine anderen Zwecke als die
        Nutzung des Services zu verwenden, sofern dies nicht zwingend durch
        anwendbares Recht andersweitig erforderlich ist.
      </p>
      <p>
        Durch die Übermittlung von Benutzermaterial an Lifesum versicherst und
        garantierst du, dass du Inhaber des Urheberrechts, der eingetragenen
        Marke und/oder anderer Rechte geistigen Eigentums bezüglich deiner
        Inhalte bist. Du erklärst dich damit einverstanden, Lifesum eine
        nicht-exklusive, übertragbare, unterlizenzierbare, gebührenfreie und
        weltweite Lizenz zur Nutzung des Benutzermaterials in dem Umfang zu
        gewähren, der für den Betrieb und die Aufrechterhaltung des Services
        durch Lifesum erforderlich ist. Die Lizenz bleibt gültig, bis das
        entsprechende Benutzermaterial durch dich oder Lifesum in
        Übereinstimmung mit diesen Bedingungen aus dem Service gelöscht wird.
      </p>

      <h3>Haftungsausschluss und Haftungsbeschränkung</h3>
      <p>
        Du nutzt den Service auf eigenes Risiko. Der Service wird ohne
        Mängelgewähr und ohne jegliche Garantien zur Verfügung gestellt, und
        Lifesum übernimmt keine Garantie dafür, dass der Service und seine
        Verfügbarkeit ununterbrochen oder fehlerfrei sind. Lifesum übernimmt
        keinerlei Haftung für Fehler oder Auslassungen in den Informationen oder
        der Software oder weiteren Dokumenten, einschließlich des
        Benutzermaterials, auf die verwiesen oder verlinkt wird. Verweise oder
        Links auf Websites Dritter werden ohne Mängelgewähr und ohne jegliche
        ausdrückliche oder stillschweigende Gewährleistung zur Verfügung
        gestellt.
      </p>
      <p>
        In keinem Fall haftet Lifesum für indirekte oder Folgeschäden, außer in
        Fällen von Vorsatz oder grober Fahrlässigkeit. Die Gesamthaftung von
        Lifesum für direkte Schäden wird, soweit gesetzlich zulässig, auf
        Folgendes beschränkt, je nachdem, welcher Betrag niedriger ist: (i) vom
        Benutzer gezahlte Mitgliedsbeiträge (ii) vom Benutzer im vorangegangenen
        Kalenderjahr gezahlte Mitgliedsbeiträge; oder (iii) 5.000 SEK.
      </p>

      <h3>Sonstiges</h3>
      <p>
        Der Klarheit halber wird an dieser Stelle erneut darauf hingewiesen,
        dass Lifesum keine Verpflichtung übernimmt, die Inhalte des
        Benutzermaterials zu überprüfen.
      </p>

      <p>
        Du bist nicht berechtigt, deine Rechte und/oder Verpflichtungen, die
        sich aus diesen Bedingungen oder der Nutzung des Services ergeben, ohne
        vorherige schriftliche Zustimmung von Lifesum an Dritte zu übertragen.
        Lifesum ist berechtigt, seine Rechte und/oder Verpflichtungen aus diesen
        Bedingungen zu übertragen.
      </p>
      <p>
        Lifesum behält sich das Recht vor, den Service jedem, zu jeder Zeit und
        aus jedem Grund zu verweigern. Lifesum kann diese Bedingungen von Zeit
        zu Zeit überarbeiten und stellt die jeweils aktuelle Version auf der
        Website von Lifesum (www.lifesum.com) zur Verfügung. Alle wesentlichen
        Änderungen werden zwischen dir und Lifesum wirksam, wenn du diese
        akzeptiert hast (z. B. durch die Nutzung der Services nach einer solchen
        Benachrichtigung oder die Verlängerung deines Abonnements).
      </p>

      <h3>Geltendes Recht und Streitbeilegung</h3>
      <p>
        Diese Bedingungen und die Nutzung der Services unterliegen schwedischem
        Recht, mit Ausnahme der Grundsätze des Kollisionsrechts. Alle
        Streitigkeiten, die sich aus oder im Zusammenhang mit diesen Bedingungen
        ergeben, werden vor den ordentlichen schwedischen Gerichten verhandelt,
        wobei das Bezirksgericht Stockholm das Gericht erster Instanz ist.
      </p>
      <h4>Kontaktangaben</h4>
      <p>
        Für weitere Informationen, Anfragen oder Unterstützung kannst du dich
        gern an Lifesum wenden. Der Kundenservice ist, wie auf der Website oder
        in den Apps angegeben, verfügbar. Die Supportkanäle können von Zeit zu
        Zeit unterschiedlich sein.
      </p>
      <dl>
        <dt>NAME DES UNTERNEHMENS</dt>
        <dd>Lifesum AB</dd>

        <dt>ANSCHRIFT</dt>
        <dd>
          Repslagargatan 17B, <br />
          118 46 Stockholm, Schweden
        </dd>

        <dt>E-MAIL</dt>
        <dd>
          {mobile && 'contact@lifesum.com'}
          {!mobile && (
            <a href="mailto:contact@lifesum.com">contact@lifesum.com</a>
          )}
        </dd>
      </dl>
    </>
  )
}

PrivacyPolicyDE.propTypes = {
  mobile: PropTypes.bool,
}

export default PrivacyPolicyDE
